import { useEffect, useRef, useState } from 'react';
import './balance-menu.css';

interface Wallet {
  balance: number | null;
  history: Array<{ id: string; amount: number; state: string; label: string; created_at: string }>;
}

export function BalanceMenu({ wallet, className }: { wallet: Wallet; className: string }) {
  const [open, setOpen] = useState(false);
  const root = useRef<HTMLDivElement>(null);
  const trigger = useRef<HTMLButtonElement>(null);
  useEffect(() => {
    if (!open) return;
    const outside = (event: PointerEvent) => {
      if (!root.current?.contains(event.target as Node)) setOpen(false);
    };
    const escape = (event: KeyboardEvent) => {
      if (event.key === 'Escape') { setOpen(false); trigger.current?.focus(); }
    };
    const navigate = () => setOpen(false);
    document.addEventListener('pointerdown', outside);
    document.addEventListener('keydown', escape);
    window.addEventListener('hashchange', navigate);
    return () => {
      document.removeEventListener('pointerdown', outside);
      document.removeEventListener('keydown', escape);
      window.removeEventListener('hashchange', navigate);
    };
  }, [open]);
  if (wallet.balance === null) return null;
  const balance = wallet.balance.toLocaleString('en-US').replace(/,/g, ' ');
  return <div className="balance-menu" ref={root} onMouseEnter={() => setOpen(true)} onMouseLeave={() => {
    if (!root.current?.contains(document.activeElement)) setOpen(false);
  }} onBlur={event => { if (!event.currentTarget.contains(event.relatedTarget)) setOpen(false); }}>
    <button ref={trigger} type="button" data-bones-balance className={className} onClick={() => setOpen(true)} aria-expanded={open} aria-controls="balance-popover" aria-label="Open bxb balance">{balance} bxb</button>
    {open && <div className="balance-menu__popover" id="balance-popover">
      <section className="balance-menu__card" aria-label="bxb balance">
        <div className="balance-menu__summary">
          <div className="balance-menu__heading"><span>Balance</span><button type="button" onClick={() => { setOpen(false); trigger.current?.focus(); }} aria-label="Close balance">×</button></div>
          <strong>{balance} <small>bxb</small></strong>
          <p>Available credits</p>
          <a href="#/settings?tab=billing" onClick={() => setOpen(false)}>Billing →</a>
        </div>
        <p className="balance-menu__hint">Reserved bxb are held while a generation is pending.</p>
        <details className="balance-menu__history">
          <summary>Transaction history <span>{wallet.history.length}</span></summary>
          <div className="balance-menu__entries" tabIndex={0} aria-label="Transactions">
            {!wallet.history.length ? <p>No transactions yet.</p> : wallet.history.map(entry => <div className="balance-menu__entry" key={entry.id}>
              <div><strong>{entry.label}</strong><small>{new Date(entry.created_at).toLocaleString()}</small></div>
              <div><strong>{entry.state === 'credit' ? '+' : ''}{entry.amount} bxb</strong><small>{entry.state}</small></div>
            </div>)}
          </div>
        </details>
      </section>
    </div>}
  </div>;
}
